import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useParams } from 'react-router-dom';
import { SocketProvider } from './contexts/SocketContext';
import TournamentClock from './components/Clock/TournamentClock';
import './App.css';
import TournamentControl from './components/Admin/TournamentControl';
import BlindStructureManager from './components/Admin/BlindStructureManager';
import TournamentSettings from './components/Admin/TournamentSettings';
import TournamentManager from './components/Admin/TournamentManager';
import EventManager from './components/Admin/EventManager';
import PlayerManager from './components/Admin/PlayerManager';
import RegistrationManager from './components/Admin/RegistrationManager';
import TableManager from './components/Admin/TableManager';
import ClockSettingsPanel from './components/Admin/ClockSettingsPanel';
import Login from './components/Auth/Login';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import AuthNav from './components/Auth/AuthNav';
import LockScreen from './components/Auth/LockScreen';

function App() {
  return (
    <SocketProvider>
      <Router>
        <div className="App">
        <LockScreen />
          <header className="App-header">
            <h1>Poker Tournament Management System</h1>
             <nav>
               <Link to="/" style={{ color: 'white', margin: '0 10px' }}>Home</Link>
               <Link to="/admin/tournaments" style={{ color: 'white', margin: '0 10px' }}>Tournaments</Link>
               <Link to="/admin/events" style={{ color: 'white', margin: '0 10px' }}>Events</Link>
               <Link to="/admin/players" style={{ color: 'white', margin: '0 10px' }}>Players</Link>
               <Link to="/admin/structures" style={{ color: 'white', margin: '0 10px' }}>Blind Structures</Link>
              <AuthNav />
             </nav>
          </header>
          
          <main className="App-main">
<Routes>
              {/* Public */}
              <Route path="/" element={<HomePage />} />
              <Route path="/clock/:tournamentId" element={<ClockPage />} />
              <Route path="/login" element={<Login />} />

              {/* Protected — admin */}
              <Route path="/control/:tournamentId" element={<ProtectedRoute><ControlPage /></ProtectedRoute>} />
              <Route path="/admin/structures" element={<ProtectedRoute><BlindStructureManager /></ProtectedRoute>} />
              <Route path="/admin/tournament/:tournamentId/settings" element={<ProtectedRoute><TournamentSettingsPage /></ProtectedRoute>} />
              <Route path="/admin/tournaments" element={<ProtectedRoute><TournamentManager /></ProtectedRoute>} />
              <Route path="/admin/events" element={<ProtectedRoute><EventManager /></ProtectedRoute>} />
              <Route path="/admin/tournament/:tournamentId/tables" element={<ProtectedRoute><TableManagerPage /></ProtectedRoute>} />
              <Route path="/admin/players" element={<ProtectedRoute><PlayerManager /></ProtectedRoute>} />
              <Route path="/admin/tournament/:tournamentId/registrations" element={<ProtectedRoute><RegistrationManagerPage /></ProtectedRoute>} />
            </Routes>
          </main>
        </div>
      </Router>
    </SocketProvider>
  );
}

const HomePage = () => (
  <div className="container">
    <h2>Welcome to the Tournament Management System</h2>
    <div className="card">
      <h3>Quick Links</h3>
      <Link to="/clock/1" className="btn">View Tournament 1 Clock</Link>
      <Link to="/control/1" style={{ color: 'white', margin: '0 10px' }}>Tournament Control</Link>
    </div>
  </div>
);

const ClockPage = () => {
  const { tournamentId } = useParams();
  console.log('ClockPage - tournamentId from URL params:', tournamentId);
  console.log('ClockPage - window.location.pathname:', window.location.pathname);
  return <TournamentClock tournamentId={tournamentId} />;
};

const ControlPage = () => {
  const { tournamentId } = useParams();
  return <TournamentControl tournamentId={tournamentId} />;
};

const TournamentSettingsPage = () => {
  const { tournamentId } = useParams();
  return <TournamentSettings tournamentId={tournamentId} />;
};

const RegistrationManagerPage = () => {
  const { tournamentId } = useParams();
  return <RegistrationManager tournamentId={tournamentId} />;
};

const TableManagerPage = () => {
  const { tournamentId } = useParams();
  return <TableManager tournamentId={tournamentId} />;
};
export default App;
